import React from "react";
import Bigcard from "./Bigcard";
import Bigtext from "./Bigtext";
import StagesOfWork from "./StagesOfWork";
import Marketplaces from "./Marketplaces";
import ImportSteps from "./ImportSteps";
import RulesOfWork from "./RulesOfWork";
import Payments from "./Payments";
import Grid from "./Grid";
import Buttons from "./Buttons";
import Smalltext from "./Smalltext";
import Instruction from "./Instruction";

const Industries = ( { data } ) => {
    if (!data || !data.bigtext) {
        return <div>Данные отсутствуют</div>; // или любой другой обработчик ошибки
    }

    return (
        <div className="flex flex-col lg:p-5 p-3 md:gap-20 gap-14">
            {data.bigcard && <Bigcard data={data}/>}
            <div className="flex flex-col gap-1">
                {data.bigtext && <Bigtext data={data}/>}
                {data.smalltext && <Smalltext data={data}/>}
            </div>
            <div className="flex flex-col gap-8">
                {data.stagesofwork && <StagesOfWork data={data}/>}
                <div className="flex flex-col gap-4">
                    {data.grid && <Grid data={data}/>}
                    {data.instruction && <Instruction data = {data}/> }
                    {data.buttons && <Buttons data={data}/>}
                </div>
            </div>
            {data.marketplaces && <Marketplaces data={data}/>}
            {data.payments && <Payments data={data}/>}
            {data.importsteps && <ImportSteps data={data}/>}
            {data.rulesofwork && <RulesOfWork data={data}/>}
            
        </div>
     );
};

export default Industries;